import { makeQueryStringDync, makeQueryFormDataDyn, errorServeiceHandler } from '../../helper'
const actions = {
  getPacksDetail: (context, filterData) => {
    let url = filterData.url
    delete filterData.url
    return new Promise( (resolve, reject) => {
      let queryStr = ''
      queryStr = makeQueryStringDync(filterData)
      fetch(context.getters.baseUrl + url + queryStr, {
        method: 'GET'
      })
      .then(errorServeiceHandler)
      .then((response) => {
        return response.json()
      }).then((data) => {
        resolve(data)
      }).catch((error) => {
        reject(error)
      });
    });
  },
  sendBroadbandDetails: (context, payload) => {
    return new Promise((resolve, reject) => {
      if (!payload) {
        reject({ error: "payload not found" });
      }
      console.log("payload", payload);
      let data = makeQueryFormDataDyn(payload);
      
      fetch(
        context.getters.baseUrl + "/subscriber/v1/subscriber/broadbanddetails",
        {
          method: "POST",
          body: data
        }
      )
        .then(errorServeiceHandler)
        .then(response => {
          return response.json();
        })
        .then(data => {
          resolve(data);
        })
        .catch(error => {
          if (context.getters.getMode == "development") {
            resolve({ success: 26312908 });
            return
          }
          console.log("error", error);
          reject(error);
        });
    });
  },
  disconnectForRefund: (context, payload) => {
    return new Promise((resolve, reject) => {
      if (!payload) {
        reject({ error: "payload not found" });
      }
      let data = makeQueryFormDataDyn(payload)
      fetch(context.getters.baseUrl + "/subscriber/v1/subscriber/disconnectpackdetails",{
        method: "POST",
        body: data
      }).then(errorServeiceHandler)
      .then(response => {
        return response.json()
      })
      .then(data => {
        resolve(data)
      })
      .catch(error => {
        if (context.getters.getMode == "development") {
          resolve({ success: 26312908 })
          return
        }
        reject(error);
      });
    });
  }
};

export default {
    actions
};


// WEBPACK FOOTER //
// ./src/store/modules/addpacks/addPacks.js